// Import GSAP
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

class PageAnimation {
  panel: HTMLElement | null

  constructor(panel: HTMLElement | null) {
    // Find all necessary elements
    this.panel = panel

    // Init functionalities if all elements has been found
    if (this.panel) {
      this.init(this.panel)
    } else {
      console.error('missing elements to properly init animations')
    }
  }

  /**
   * Init all default functionalities
   */
  init(panel: HTMLElement) {
    const panelName = panel.getAttribute('data-animation-section')

    switch (panelName) {
      case 'parallax':
        this.parallax(panel)
        break

      default:
        break
    }
  }

  parallax(panel: HTMLElement) {
    gsap.to(`[data-parralax]`, {
      y: -150, // im większa wartość, tym mocniejszy efekt
      ease: "none",
      scrollTrigger: {
        trigger: panel,
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });
  }

}

window.addEventListener('load', () => {
  // Find all section to full page animation
  const panels = document.querySelectorAll<HTMLElement>(
    '[data-animation-section]',
  )

  if (panels.length > 0) {
    panels.forEach((panel) => {
      setTimeout(() => {
        new PageAnimation(panel)
      }, 500)
    })
  }
})
